export default {
    AverageBreathe: "Среднее дыхание",
    MeanHeartbeat: "Средний пульс",
    NumberOfTurnovers: "Количество переворотов",
    BodyActivityRatio: "Доля выраженных движений тела",
    NumberOfApnea: "Количество апноэ",

    SleepQualityScore: "Оценка качества сна",
    TotalSleepDuration: "Общая длительность сна",
    WakefulnessDuration: "Доля бодрствования",
    LightSleepDuration: "Доля поверхностного сна",
    DeepSleepDuration: "Доля глубокого сна",
    TimeAwayFromBed: "Время вне кровати",
    OutOfBedTimes: "Количество подъёмов с кровати",
}
